import React, {useState, useEffect, useCallback} from 'react';
import {    
            AppBar,
            Grid,
            Paper,
            Tab,
            Tabs,
        } from '@material-ui/core';
import { 
   // AddToQueue as AddToQueueicon,
  //  Ballot as BallotIcon,
    //ExpandMore as ExpandMoreIcon
} from '@material-ui/icons';
//import { red, blue } from '@material-ui/core/colors';
import { useAuth } from '../Auth';
import RegisterEquipos from './Registrar';
import ListedEquipos from './Listado';

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

const YounetEquipos = (props)=>{
    const size = useWindowSize();
    const { authTokens, setOpen } = useAuth(); 
    const [ data, setData ] = useState([]);
    const [ valueTab, setValueTab ] = useState(0);
    const [ dataZona, setDataZona ] = useState([]);
    const [ Tipos, setTipos ] = useState([]);
    const [ Marcas, setMarcas ] = useState([]);
    const [ ModelosList, setModelosList ] = useState([]);
   
    useEffect(
        ()=>{
            (async ()=>{
                setOpen(false);
                const Peticion = await fetch('/api/equipos');
                const result = await Peticion.json();
                const dataZonas = await fetch('/api/zonas');
                const resultZonas = await dataZonas.json();
                const lTipos = await fetch('/api/Tipos');
                const lMarcas = await fetch('/api/Marcas');
                const lModelos = await fetch('/api/EquiposAls');
                const jTipos = await lTipos.json();
                const jMarcas = await lMarcas.json();
                const jModelos = await lModelos.json();
                if(authTokens.Type === 'ADMINISTRADOR'){ 
                    setDataZona(resultZonas);
                    setData(result);
                }else{
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona.toString()));
                    const resultFil = result.filter(value=> ZonasArr.includes(value.Zona.toString()));
                    setDataZona(arrFilZona); 
                    setData(resultFil);
                }
                setTipos(jTipos);
                setMarcas(jMarcas);
                setModelosList(jModelos);
            })();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const handleProcess = useCallback((props)=>{
        const arr2 = [...data];
        arr2.push(props);
        setData(arr2);
    },[data]);

    const handleUpdate = useCallback((props)=>{
        const arrBack = [...data];
        const arr2 = arrBack.map(value=>{
            if(value._id === props._id){
                return props
            }else{
                return value
            }
        });
        setData(arr2);
    },[data]);

    const handleDelete = useCallback((props)=>{
        const arrBack = [...data];
        const arr2 = arrBack.filter(value=> value._id !== props._id)
        setData(arr2);
    },[data]);

    const handleChangeTab = (e,value)=>{ setValueTab(value); };

    return(
        <Grid container justifyContent='center' style={{padding:10}}>       
            <Grid item xs={12}>
                <Paper style={{width:'99.9%', overflowX:'hidden',height:size.height === undefined ? 0 : size.height - 95}}>
                    <AppBar position="static" style={{position:'sticky', top:0, zIndex:2}}>
                        <Tabs value={valueTab} onChange={handleChangeTab} aria-label="simple tabs example" centered>
                            <Tab label="REGISTRAR" />
                            <Tab label="LISTADO" />
                        </Tabs>
                    </AppBar>
                    <div
                        role="tabpanel"
                        hidden={valueTab !== 0}
                        id={`simple-tabpanel-${0}`}
                        aria-labelledby={`simple-tab-${0}`}
                    >
                    {valueTab === 0 && (
                        <RegisterEquipos data={data} dataZona={dataZona} handleProcess={handleProcess} handleUpdate={handleUpdate} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/>
                    )}
                    </div>
                    <div
                        role="tabpanel"
                        hidden={valueTab !== 1}
                        id={`simple-tabpanel-${1}`}
                        aria-labelledby={`simple-tab-${1}`}
                    >
                    {valueTab === 1 && (
                        <ListedEquipos data={data} dataZona={dataZona} handleProcess={handleProcess} handleUpdate={handleUpdate} handleDelete={handleDelete} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/>
                    )}
                    </div>
                </Paper>
            </Grid>
        </Grid>
    )
};

export default YounetEquipos;